import { getReadProvider, TChainId, VAULT_CONTRACT } from 'modules/api';

import { fromSatoshi } from 'modules/api/utils/convertSatoshi';
import { VAULT_ABI } from '../abi';

export async function getUserVaultSupply(
  address: string,
  chainId: TChainId,
): Promise<number> {
  const provider = await getReadProvider(chainId);

  const vaultContract = provider.createContract(VAULT_ABI, VAULT_CONTRACT);

  // returns total user supply lbtc + ebtc
  const balance: bigint = await vaultContract.methods.balanceOf(address).call();

  return fromSatoshi(balance.toString());
}
